import { type LegendOptions, type Plugin } from 'chart.js';

export const emptyStateDoughnut: Plugin<'doughnut'> = {
  id: 'emptyDoughnut',
  afterDraw(chart, _, options) {
    const { color, width, radiusDecrease } = options;

    const legendOptions = chart.options.plugins
      .legend as LegendOptions<'doughnut'>;

    if (!legendOptions.labels?.generateLabels) {
      return;
    }

    const hasData = legendOptions.labels
      .generateLabels(chart)
      .some(data => !data.hidden);

    if (hasData) {
      return;
    }

    const {
      chartArea: { left, top, right, bottom },
      ctx,
    } = chart;

    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;
    const r = Math.min(right - left, bottom - top) / 2;

    ctx.beginPath();
    ctx.lineWidth = width || 1;
    ctx.strokeStyle = color || 'black';
    ctx.arc(centerX, centerY, r - radiusDecrease || 0, 0, 2 * Math.PI);
    ctx.stroke();
  },
};
